<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('announcement') }}</h4>
    <div>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr style="background-color: #F1F5FB">
            <th>{{ $t('announcementName') }}</th> <th>{{ $t('ext') }}</th>
            <th class="th-80 text-right">
              <span @click="create" class="btn-add"><i class="icon16-plus-circle-gadient"></i></span>
            </th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>{{ item.ext }}</td>
            <td class="text-right">
              <button @click="update(item._id)" class="btn btn-outline-gray btn-sm"
                      type="button">
                <font-awesome-icon icon="info"/>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noAnnouncementFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <b-modal size="lg" v-model="showForm" :title="$t('announcementFormTitle')" @ok="save" no-close-on-backdrop
               no-enforce-focus>
        <div class="row">
          <div class="col-md">
            <form-input :label="$t('announcementName')" :model="formModel" attribute="name" :errors="formErrors" :placeholder="$t('announcementNamePlaceholder')"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('announcementExtPlaceholder')"></form-input>
            <recording-select :label="$t('recording')" :model="formModel" attribute="recording" :errors="formErrors"></recording-select>
            <target-select :label="$t('continueTarget')" :model="formModel" attribute="continueTarget" :errors="formErrors"></target-select>
            <form-checkbox :chk-label="$t('announcementAnswer')" :model="formModel" :errors="formErrors" attribute="answer"></form-checkbox>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import RecordingSelect from "@/components/ClientRecordingSelect.vue";
import TargetSelect from "@/components/ClientTargetSelect.vue";

export default {
  props: ['client'],
  mixins: [list, crud],
  components: {TargetSelect, RecordingSelect},
  data: function () {
    return {
      service: '/announcement',
      autoLoad: true,
      defaultFilterFormModel: {
        client: this.client._id
      },
    }
  },
  i18n: {
    messages: {
      vi: {
        announcement: "Thông báo",
        announcementFormTitle: "Thông tin thông báo",
        announcementName: "Tên thông báo",
        recording: "File ghi âm",
        continueTarget: "Đích đến sau thông báo (kết thúc cuộc gọi nếu không chọn)",
        announcementAnswer: "Nghe máy (tính tiền) khi phát thông báo",
        close: "Đóng",
        noAnnouncementFound: "Chưa có thông báo nào được thiết lập",
      },
      en: {
        announcement: "Thông báo",
        announcementFormTitle: "Thông tin thông báo",
        announcementName: "Tên thông báo",
        recording: "File ghi âm",
        continueTarget: "Đích đến sau thông báo (kết thúc cuộc gọi nếu không chọn)",
        announcementAnswer: "Nghe máy (tính tiền) khi phát thông báo",
        close: "Đóng",
        noAnnouncementFound: "Chưa có thông báo nào được thiết lập",
      }
    }
  }

}
</script>